import React, { useState } from 'react';
import { AnimatePresence } from "framer-motion";
import {
  CloseButton,
  ImageContainer,
  MotionImage,
  Overlay,
  StyledText
} from "./fullscreenImagesViewer.styles";

interface FullscreenImageViewerProps {
  images: string[];
  initialIndex: number;
  onClose: () => void;
  text?: string;
}

const imageVariants = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 },
};

const FullscreenImageViewer: React.FC<FullscreenImageViewerProps> = ({images, initialIndex, onClose, text}) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const handlePrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <Overlay onClick={onClose}>
      {/*<LeftArrow onClick={handlePrev}>&larr;</LeftArrow>*/}
      <ImageContainer onClick={(e) => e.stopPropagation()}>
        <AnimatePresence mode="wait">
          <MotionImage
            key={images[currentIndex]}
            src={images[currentIndex]}
            alt={`Image ${currentIndex + 1}`}
            variants={imageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          />
          {text && <StyledText isImageCaption>{text}</StyledText>}
        </AnimatePresence>
      </ImageContainer>
      {/*<RightArrow onClick={handleNext}>&rarr;</RightArrow>*/}
      <CloseButton onClick={onClose}>&times;</CloseButton>
    </Overlay>
  );
};

export default FullscreenImageViewer;
